import { UrlConstants } from "../url.constants";
export class ApiBackupConstants {
    static URL = UrlConstants.API_V2 + "Backup";
    static MODULE_PATH = "Module";
    static ORGANISATION_PATH = "Organisation";
    static FUNCTION_BACKUP_SETTINGS = "BackupSettings";
    static FUNCTION_RESTORE_SETTINGS = "RestoreSettings";
    static FUNCTION_GET_RESTORE_SETTINGS_JOB_STATUS = "GetRestoreSettingsJobStatus";
}
